<template>
<div class="valuesExplorer">
    <div class="canvas-layer"></div>
    <div v-for="(item, index) in values" :key="item.name" :value="item.name" :class="['value-'+index, 'valueItem']">
        <svg>
            <svg viewBox="-50 -50 340 340">
                <path id="curve" d="M1.00001 120C1 54.2781 54.2781 1.00002 120 1.00001C185.722 1 239 54.2781 239 120" fill="transparent"/>
                <text width="340" :class="item.color">
                    <textPath alignment-baseline="top" xlink:href="#curve" startOffset="50%" text-anchor="middle">
                    {{item.name}}
                    </textPath>
                </text>
            </svg>
            <svg y="95" viewBox="-25 -25 290 290">
                <path id="curve2" d="M1.00001 -2.08066e-05C1 65.7219 54.2781 119 120 119C185.722 119 239 65.7219 239 0" fill="transparent"/>
                <text class="bottom" width="300" :class="item.color">
                    <textPath alignment-baseline="top" xlink:href="#curve2" startOffset="50%" text-anchor="middle">
                    {{item.name}}
                    </textPath>
                </text>
            </svg>
        </svg>
    </div>
    <div class="underlay">
        <div class="dragTargetContainer">
            <div class="dragTarget" value="1"></div>
            <div class="dragTarget" value="2"></div>
            <div class="dragTarget" value="3"></div>
        </div>
    </div>
    
</div>
    
</template>

<script>
import Matter from 'matter-js'
import $ from 'jquery'

import physicalIco from '../assets/static/physicalIco.svg'
import mentalIco from '../assets/static/mentalIco.svg'
import relationshipsIco from '../assets/static/relationshipsIco.svg'
import spiritualityIco from '../assets/static/spiritualityIco.svg'
import financialIco from '../assets/static/financialIco.svg'
import timeIco from '../assets/static/timeIco.svg'
import cognitiveIco from '../assets/static/cognitiveIco.svg'

export default {
    name: 'Page',
    props: ['value'],
    mixins: [],
    data() {
        return {
            engine: null,
            dragging: false,
            ballSize: 120,
            selection: {
                choice_1:null,
                choice_2:null,
                choice_3:null,
            },
            values: [
                {name: 'Physical Health', selected:false, color: 'dark', sprite: physicalIco},
                {name: 'Financial Stability', selected:false, color: 'dark', sprite: financialIco},
                {name: 'Social Connections', selected:false, color: 'dark', sprite: relationshipsIco},
                {name: 'Cognitive Health', selected:false, color: 'light', sprite: cognitiveIco},
                {name: 'Spirituality', selected:false, color: 'dark', sprite: spiritualityIco},
                {name: 'Time Management', selected:false, color: 'dark', sprite: timeIco},
                {name: 'Mental Health', selected:false, color: 'light', sprite: mentalIco}
            ]
        }
    },

    components: {
    },

    methods: {
        breakLines(string) {
            return string.replace(" ", "<br>")
        },
        updateSelection(value) {
            if (value == null) return
            let newData = {
                choice_A: value.choice_1,
                choice_B: value.choice_2,
                choice_C: value.choice_3
            }
            this.$emit('input', newData);
        },
        targetCheck(body) {
            let x = body.position.x
            let y = body.position.y
            let zone = $('.dragTargetContainer')[0].getBoundingClientRect()
            if (zone.x <= x && x <= zone.x + zone.width && zone.y <= y && y <= zone.y + zone.height) {
                let third = parseInt((x-zone.x)/zone.width*3)+1
                let target = $('.dragTarget[value='+third+']').offset()
                let size = $('.dragTarget[value='+third+']').width()/2+2
                let dest = {
                    x: target.left+size,
                    y: target.top+size,
                    target: third
                }
                this.$sound('spot'+third)
                return dest
            }
            return false
        }
    },

    computed: {
    },

    watch: {
    },

    created() {
    },

    destroyed() {
        Matter.World.clear(this.engine.world)
        Matter.Engine.clear(this.engine)
        this.engine.events = {}
    },

    mounted() {
        let _this = this
        let Engine = Matter.Engine,
            Render = Matter.Render,
            World = Matter.World,
            Mouse = Matter.Mouse,
            Bodies = Matter.Bodies,
            Common = Matter.Common,
            Vertices = Matter.Vertices,
            Svg = Matter.Svg,
            Constraint = Matter.Constraint,
            Composites = Matter.Composites,
            MouseConstraint = Matter.MouseConstraint

        // create an engine
        this.engine = Engine.create()
        let idRAF = null
        let render

        var init = () => {
            let numm = Math.random()

            cancelAnimationFrame(idRAF)
            let width = 1080
            let height = 1920
            let offset = -1
            this.engine.events = {}
            World.clear(this.engine.world)
            Engine.clear(this.engine)
            this.engine = Engine.create()
            this.engine.world.gravity.x = 0
            this.engine.world.gravity.y = 10
            this.engine.enableSleeping = true
            // create a renderer
            render = Render.create({
                element: $('.canvas-layer')[0],
                engine: this.engine,
                options: {
                wireframes: false,
                background: 'transparent',
                width: width,
                height: height,
                showDebug: false,
                showBroadphase: false,
                showBounds: false,
                showVelocity: false,
                showCollisions: false,
                showSeparations: false,
                showAxes: false,
                showPositions: false,
                showAngleIndicator: false,
                showIds: false,
                showShadows: false,
                showVertexNumbers: false,
                showConvexHulls: false,
                showInternalEdges: false,
                showMousePosition: false
                }
            })
            World.add(this.engine.world, [
                // X, Y, WIDTH, HEIGHT
                Bodies.rectangle(width / 2, 0 - offset, width, 1, {isStatic: true, render: { fillStyle: "#FFFFFF"}}),
                Bodies.rectangle(width / 2, height - offset, width, 1, {isStatic: true,render: {fillStyle: "#FFFFFF"}}),
                Bodies.rectangle(offset, height*20, 1, height*40, {isStatic: true,render: {fillStyle: "#FFFFFF"}}),
                Bodies.rectangle(width - offset, height*20, 1, height*40, {isStatic: true,render: {fillStyle: "#FFFFFF"}}),
                // Button blocker
                Bodies.rectangle(width*.51, height*.922, width*.475, width*.1, {title: "buttonBlocker", isStatic: true,render: {fillStyle: "transparent"}})
            ])
            let radius = this.ballSize;
            for (let i = 0; i < 7; i++) {
                let originX = (radius*3)+(i%2)*(radius*3)
                let originY = i<4?3*radius:5*radius
                World.add(this.engine.world, Bodies.circle(
                    originX, originY, radius, {
                        title: "val"+i,
                        slop: 5,
                        density: 100,
                        friction: 1,
                        restitution: 0,
                        render: {
                            sprite: {
                                texture: this.values[i].sprite,
                            }
                        }
                    }
                ))
            }
            // add mouse control
            let mouseConstraint = Matter.MouseConstraint.create(this.engine, {
                element: $('.canvas-layer')[0],
                constraint: {
                    render: {
                    visible: false
                    },
                    stiffness:0.8
                }
            });
            Matter.World.add(this.engine.world, mouseConstraint);
            
            // Motion callback
            let startDrag = (event) => {
                if (event.body.title == "buttonBlocker") return
                this.dragging = true
                event.body.isStatic = false
                this.$sound('bump')
            }
            let moved = ({name, mouse, source}) => {
                if(source.body){
                    if (bringBack(source.body)) {
                        source.body.collisionFilter.category = 0x0004
                        source.constraint.bodyB = null
                    }
                }
            }
            let bringBack = (body) => {
                let {x} = body.position
                let {y} = body.position
                let outside = false;
                if (x < radius-10) {
                    body.position.x = radius-10
                    outside = true
                } else if (x > width-radius+10) {
                    body.position.x = width-radius+10
                    outside = true
                }
                if (y < radius-10) {
                    body.position.y = radius-10;
                    outside = true
                } else if (y > height-radius+10) {
                    body.position.y = height-radius+10
                    outside = true
                }
                return outside
            }
            let endDrag = ({mouse, body}) => {
                this.dragging = false
                if (body.title == "buttonBlocker") return
                let bodyID = body.title.substr(3)
                let selectionName = $(".value-"+bodyID).attr('value')
                // If we are in the hit zone disable gravity on that ball
                let hit = this.targetCheck(body)
                if (hit) {
                    // Add selection to data
                    this.selection['choice_'+hit.target] = selectionName
                    // Stop gravity on it, and animate it to the slot
                    body.isStatic = true;
                    let startX = body.position.x
                    let startY = body.position.y
                    var obj = { x:startX, y:startY }
                    var JSobject = this.$anime({
                        targets: obj,
                        x: hit.x,
                        y: hit.y,
                        duration: 1000,
                        elasticity: 750,
                        update: () => {
                            Matter.Body.setPosition(body, obj)
                        }
                    });
                } else {
                    // cleanup data
                    // if ball is in array, remove it
                    Object.keys(this.selection).forEach((key) => {
                        if (this.selection[key] == selectionName) {
                            this.selection[key] = null
                        }
                    });
                }
                //console.log(_this.selection)
                this.updateSelection(this.selection)
            }
            Matter.Events.on(mouseConstraint, "startdrag", startDrag)
            Matter.Events.on(mouseConstraint, "mousemove", moved)
            Matter.Events.on(mouseConstraint, "enddrag", endDrag)
            
            // run the engine
            Engine.run(this.engine)

            // run the renderer
            Render.run(render)
            
            let a, b, c
            this.engine.world.gravity.y = 10
            this.engine.world.gravity.x = 0
            
            let update = () => {
                if (grove && grove[1].position.x) {
                    for (let i = 0; i < grove.length; i++) {
                        $(".value-"+(i-2)).css({
                            left : grove[i].position.x-grove[i].circleRadius+"px",
                            top : grove[i].position.y+"px"
                        });
                    }
                }
                idRAF = requestAnimationFrame(update.bind(this))
            }
            update()
        }
        init()
        let grove = Matter.Composite.allBodies(this.engine.world)
        grove = grove.slice(3, grove.length)
        let groveLookup = [];
        for (let i = 0; i < grove.length; i++) {
            let peach = {isHidden: false, circleRadius: grove[i].circleRadius, prevX: 0, prevY: 0, isStatic: false }
            groveLookup.push(peach)
        }
    }

}
</script>

<style lang="scss">
@import "../styles/variables.scss";
.valuesExplorer {
    top: 0;
    left: 0;
    right: 0;
    height: 1920px;
    overflow: hidden;
    position: absolute;
    z-index: 0;
    svg {
        width: 30vw;
        height: 30vw;
        text-align: center;
        text {
            text-align: center;
            font-family: "Walsheim";
            fill: $color-dark;
            text-transform: uppercase;
            font-size: 2.5vw;
            letter-spacing: .3vw;
            textPath {
                text-anchor: "middle";
            }
            &.bottom {
                font-size: 2.2vw;
                letter-spacing: .4vw;
            }
            &.light {
                fill: $color-cream;
            }
        }
    }
    .valueItem {
        position: absolute;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #FFF;
        font-size: 33px;
        line-height: 1.2;
        font-weight: 700;
        height: 20vw;
        margin-top: -10vw;
        z-index: 10000;
        pointer-events: none;
        width: 240px;
        cursor: pointer;
    }
}
.canvas-layer {
    position: relative;
    height: 100vh;
}
.underlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    z-index: -1;
    .dragTargetContainer {
        position: absolute;
        top: 45vh;
        left: 14vw;
        width: 70vw;
        height: 22vw;
        padding: 1vw;
        .dragTarget {
            display: inline-block;
            width: 22vw;
            height: 22vw;
            border: solid 3px $color-dark;
            border-radius: 12vw;
            box-sizing: border-box;
            margin-right: 2vw;
            opacity: .25;
            &:last-child {
                margin-right: 0;
            }
        }
    }
    .label {
        display: inline-block;
        width: 50vw;
        height: 100vh;
        color: $color-darkBeige;
        font-family: "Walsheim";
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 3vw;
        letter-spacing: .2vw;
        &:first-child {
            border-right: dashed 4px $color-lightBeige;
        }
    }
}
#surveyContainer .pValues input.sv_next_btn {
    position: absolute;
    bottom: 5vh;
    left: 50vw;
    margin-left: -24vw;
}
</style>